import { render, staticRenderFns } from "./SaleFilters.vue?vue&type=template&id=b16c46e0&scoped=true"
import script from "./SaleFilters.vue?vue&type=script&lang=ts"
export * from "./SaleFilters.vue?vue&type=script&lang=ts"
import style0 from "./SaleFilters.vue?vue&type=style&index=0&id=b16c46e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16c46e0",
  null
  
)

export default component.exports